import { Duration } from "luxon";

import { MemSize } from "@core/foundation/units";
import { z } from "@core/zod";

export const ADMIN_EMAIL = "ilia.liubinskii@gmail.com";

export const AGENTS = [
  "agent1",
  "agent2",
  "agent3",
  "agent4",
  "agent5",
  "agent6",
] as const;

export type Agent = (typeof AGENTS)[number];

export const AgentSchema = z.enum(AGENTS);

export const COST_GUARD_CONFIG = {
  alertCloudFrontEgress: MemSize.gigabytes(1),
  alertDynamodbReads: 40_000,
  alertDynamodbWrites: 40_000,
  alertLambdaDuration: Duration.fromObject({ minutes: 200 }),
  alertLambdaInvocations: 100_000,
  alertMonthlyUsd: 50,
  alertWebCpuTime: Duration.fromObject({ minutes: 20 }),
  alertWebEnvironmentTime: Duration.fromObject({ minutes: 2000 }),
  alertWebRequests: 10_000,
  evaluationWindow: Duration.fromObject({ hours: 1 }),
  shutdownCloudFrontEgress: MemSize.gigabytes(2),
  shutdownDynamodbReads: 80_000,
  shutdownDynamodbWrites: 80_000,
  shutdownLambdaDuration: Duration.fromObject({ minutes: 400 }),
  shutdownLambdaInvocations: 200_000,
  shutdownMonthlyUsd: 100,
  shutdownWebCpuTime: Duration.fromObject({ minutes: 40 }),
  shutdownWebEnvironmentTime: Duration.fromObject({ minutes: 4000 }),
  shutdownWebRequests: 20_000,
} as const;

export const COST_THROTTLE_CONFIG = {
  cloudFrontEvaluationWindow: Duration.fromObject({ minutes: 5 }),
  cloudFrontRateLimit: 10_000,
  ddbMaxReadRequestUnits: { other: 20, prod: 80 },
  ddbMaxWriteRequestUnits: { other: 20, prod: 80 },
  lambdaReservedConcurrentExecutions: 250,
  webFunctionLimits: { maxEnvironments: 3, rateLimit: 100 },
} as const;

export const DEV_STAGES = ["dev1", "dev2", "dev3"] as const;

export type DevStage = (typeof DEV_STAGES)[number];

export const GITHUB_APPS = {
  agent1: {
    appId: "3436379",
    installationId: 125_407_542,
    name: "aptblocks-agent1",
  },
  agent2: {
    appId: "3436383",
    installationId: 125_398_753,
    name: "aptblocks-agent2",
  },
  agent3: {
    appId: "3436385",
    installationId: 125_398_792,
    name: "aptblocks-agent3",
  },
  agent4: {
    appId: "4585005",
    installationId: 153_528_483,
    name: "aptblocks-agent4",
  },
  agent5: {
    appId: "4585004",
    installationId: 153_528_513,
    name: "aptblocks-agent5",
  },
  agent6: {
    appId: "4585003",
    installationId: 153_528_532,
    name: "aptblocks-agent6",
  },
} as const;

export const GITHUB_SYSTEM_APP = {
  appId: "5327151",
  installationId: 171_636_885,
  name: "aptblocks-system",
} as const;

export const GITHUB_REPO = {
  baseBranch: "master",
  baseBranchWorkflow: ".github/workflows/master.yml",
  devStageDeployWorkflow: ".github/workflows/deploy-dev-stage.yml",
  devStageResetWorkflow: ".github/workflows/reset-dev-stages.yml",
  name: "aptblocks",
  owner: "aptblocks-com",
  pullRequestWorkflow: ".github/workflows/pull-request.yml",
} as const;

export const LINEAR_APPS = {
  agent1: {
    clientId: "1650539b7ddf9c11828a7004fdc836e5",
    name: "aptblocks-agent1",
    userId: "13ae2c9a-dbfe-4f29-9ccb-4086ab867cba",
  },
  agent2: {
    clientId: "c7093b0a068ffd21fd8b897ed685cdc1",
    name: "aptblocks-agent2",
    userId: "898a1f16-30d1-45a1-a408-375174a3457d",
  },
  agent3: {
    clientId: "efef5e0102aeef41b0f0e0295c34e469",
    name: "aptblocks-agent3",
    userId: "ef6c6049-59b2-4fe0-a2b3-7265454a2804",
  },
  agent4: {
    clientId: "210517ca2b8db46f1216b8a6d021577b",
    name: "aptblocks-agent4",
    userId: "f6fdd7d7-90c9-4b0f-988e-6ca3ea2239e5",
  },
  agent5: {
    clientId: "8370db39a640880b7405780ec6fdf419",
    name: "aptblocks-agent5",
    userId: "1aee74f8-3d6f-45dc-bc02-3a61ee776ebc",
  },
  agent6: {
    clientId: "caf315d40b899741e3c547bff7a44cf6",
    name: "aptblocks-agent6",
    userId: "0665d076-5492-490a-9d3e-4a95d6e1c177",
  },
} as const;

export const LINEAR_ASSIGNEE = "Ilia Liubinskii";

export const LINEAR_SYSTEM_APP = {
  clientId: "7d1252a43e93d3bf57d5c77f13c36b4b",
} as const;

export const LINEAR_SYSTEM_READONLY_APP = {
  clientId: "124aa3c16aeb3b182dfb692f024f38c1",
} as const;

export const LINEAR_TEAM = "AptBlocks";

export const OAUTH_CONSENT_PATH = "/oauth/consent";

export const PROJECT_DOMAIN = "aptblocks.com";

export const API_DOMAIN = `api.${PROJECT_DOMAIN}`;

export const TELEGRAM_ADMIN_CHAT_ID = 1_197_098_273;
